import I18n from "i18n-js";
import React from "react"
import PhoneInput from 'react-phone-number-input'

export default class PhoneNumberInput extends React.Component {
	
	constructor(props) {
		super(props);

    // this.state = {
    //   value: this.props.value
    // }

    this.onChange = this.onChange.bind(this)
	}

	render() {
		return (
			<div className="row">
				<div className="col-sm-12">
					<div className="PhoneNumberInput">
            <span className="fa fa-phone"></span>
						{/*<input type="text" className="has-icon" placeholder={I18n.t('fields.phone_number')} />*/}
            <PhoneInput
              defaultCountry="US"
              placeholder={I18n.t('fields.phone_number')}
              value={this.props.value}
              onChange={this.onChange} />
					</div>
				</div>
			</div>
		);	
	}

  onChange(value) {
    //this.setState({value: value})
    this.props.onChange({
      target: {
        value: value,
        name: this.props.name
      }
    })
  }

}